import { LinkedinLogo } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";

import type { NavigatorLead } from "../../../../../types";

export default function LeadsListItem({ lead }: { lead: NavigatorLead }) {
  const {
    picture,
    id,
    full_name: fullName,
    urn,
    title,
    company_name: companyName,
    premium: isPremium,
  } = lead;

  return (
    <a
      href={`https://linkedin.com/in/${urn}`}
      className="flex items-center gap-x-2 rounded-3xl border bg-white border-black-200 p-3 transition-colors hover:bg-black-100"
      aria-label="LinkedIn Profile Url"
      key={id}
      target="_blank"
      rel="noreferrer"
    >
      <ProfileImage src={picture} />

      <div className="flex flex-1 flex-col gap-y-0.5 overflow-hidden">
        <span className="line-clamp-1 text-left text-sm-bold">{fullName}</span>
        <RenderIf condition={!!title || !!companyName}>
          <div className="flex items-center gap-x-0.5 overflow-hidden">
            {title && (
              <span className="max-w-min flex-1 truncate text-xs-medium text-black-500">
                {title}
              </span>
            )}
            {companyName && (
              <span className="max-w-min flex-1 truncate text-xs-medium text-black-500">
                · {companyName}
              </span>
            )}
          </div>
        </RenderIf>
      </div>

      <LinkedinLogo
        weight="fill"
        size={20}
        className={clsx(isPremium && "fill-yellow-500")}
      />
    </a>
  );
}
